module.exports = __webpack_public_path__ + "Posters0002-f094f993cffacf570674f296e3a6505e.png";